export const Reject = {
  Message: "message" as const,
}

export const Assign = {
  AssignPersonId: "assignPersonId" as const,
  AssignPersonName: "assignPersonName" as const,
  Message: "message" as const,
}

export const SalaryFilter = {
  YearMonth: "yearMonth" as const,
  State: "state" as const,
}

